import React from 'react';
import { enumValue } from '~/util';
import { ServicesContext } from '~/services';
import { Notes } from '../Notes';

interface ReminderNotesProps {
    reminderId: number;
}

export function ReminderNotes({ reminderId }: ReminderNotesProps) {
    const servicesContext = React.useContext(ServicesContext);

    async function addNote(note: NewNoteType) {
        await servicesContext.api.call({
            method: 'PUT',
            url: `/api/tasks/${reminderId}`,
            data: note,
        });
    }

    return (
        <Notes
            addNote={addNote}
            entityId={reminderId}
            noteEntity="task.id"
            noteType={enumValue(['note', 'type', 'Task Note']) as number}
        />
    );
}
